import * as R from 'remeda';
import { Form } from './formTypes';

export const joinElementsByNewline = (
  emailList: Array<string> | null
): string => emailList?.join('\r\n') ?? '';

export const joinElementsWithComma = (
  mimeTypes: Array<string> | null
): string => mimeTypes?.join(', ') ?? '';

export const parseElements = (mimeTypes: string) =>
  R.pipe(mimeTypes.split(/[ ,]+/), R.filter(R.isTruthy));

export const formatMimeTypeList = (mimeTypeList: string) =>
  joinElementsWithComma(parseElements(mimeTypeList));

export const formatFileNameList = (fileNameList: string) =>
  joinElementsByNewline(parseElementsSeparatedByNewline(fileNameList));

export const parseElementsSeparatedByNewline = (stringAddresses: string) =>
  R.pipe(stringAddresses.split(/\r\n|\n|\n\r+/g), R.filter(R.isTruthy));

export const parseEmailAddresses = (stringAddresses: string) =>
  R.pipe(stringAddresses.split(/,| |\r\n|\n|\n\r+/g), R.filter(R.isTruthy));

export const sanitizeValuesToCompare = (data: Partial<Form>): Partial<Form> => {
  const {
    whiteList,
    blackList,
    whiteListEnabled,
    blackListEnabled,
    ...restWatchValues
  } = data;
  return {
    whiteList: whiteListEnabled ? whiteList : '',
    blackList: blackListEnabled ? blackList : '',
    ...restWatchValues,
  };
};

export const parseEmailList = (emailsString: string, condition: boolean) =>
  condition ? parseEmailAddresses(emailsString) : [];

export const formatEmailList = (emailList: string, shouldReturnList: boolean) =>
  shouldReturnList ? joinElementsByNewline(parseEmailAddresses(emailList)) : '';
